import api from 'service/api'

const dponetAPI = api.create('dponet')

const list = async ({ ...params }) => {
  return await dponetAPI.get('/trainning_journeys', { params })
}

const show = async ({ trainningJourneyId, ...params }) => {
  return await dponetAPI.get(`/trainning_journeys/${trainningJourneyId}`, {
    params,
  })
}

const showByUser = async ({ trainningJourneyId }) => {
  return await dponetAPI.get(
    `/trainning_journeys/${trainningJourneyId}/show_by_user`,
  )
}

const validateCertification = async ({ trainningJourneyId }) => {
  return await dponetAPI.post(
    `/trainning_journeys/${trainningJourneyId}/validate_certification`,
  )
}

const removeAnswers = async ({ trainningJourneyId }) => {
  return await dponetAPI.delete(
    `/trainning_journeys/${trainningJourneyId}/remove_answers`,
  )
}

const answer = async ({ questionId, ...data }) => {
  return await dponetAPI.post(`/trainning_questions/${questionId}/answer`, data)
}

const showUserCertifications = async () => {
  return await dponetAPI.get(`/trainning_journeys/show_user_certifications`)
}

const listDepartmentCertifications = async ({ ...params }) => {
  return await dponetAPI.get(
    `/trainning_journeys/list_department_certifications`,
    {
      params,
    },
  )
}

const getStatsExcel = async ({ ...params }) => {
  return await dponetAPI.post('/trainning_journeys/report_stats_to_excel', {
    ...params,
  })
}

const usersPendingTrainnings = async () => {
  return await dponetAPI.get('/trainning_journeys/users_pending_trainnings')
}

const notifyPendingTrainnings = async ({ userIds }) => {
  return await dponetAPI.post('/trainning_journeys/notify_pending_trainnings', {
    trainningJourneys: { userIds },
  })
}

const trainningJourneys = {
  answer,
  getStatsExcel,
  list,
  listDepartmentCertifications,
  notifyPendingTrainnings,
  removeAnswers,
  show,
  showByUser,
  showUserCertifications,
  usersPendingTrainnings,
  validateCertification,
}

export default trainningJourneys
